import { coreBOSMap } from "./corebos-map.js";
import { descriptors } from "./descriptors/index.js";
// Reference fields are named after the coreBOS column (acctopolicy, pacclinktocontact): label them
// with the record type they point at, in Italian (UI contract rule 11).
const BASE_LABELS = { contact: "Persona", account: "Organizzazione", user: "Assegnato a", product: "Prodotto" };
const refLabel = (target) => descriptors.find((d) => d.slug === target)?.label.singular ?? BASE_LABELS[target] ?? target;
function fieldCatalog(descriptor) {
    const fields = new Map();
    const add = (field) => {
        if (!fields.has(field.name))
            fields.set(field.name, field);
    };
    descriptor.fields.forEach(add);
    for (const relation of descriptor.relations ?? []) {
        if (relation.kind !== "belongsTo")
            continue;
        add({ name: relation.name, type: "ref", refTo: relation.target, label: refLabel(relation.target) });
        add({ name: `${relation.name}_id`, type: "ref", refTo: relation.target, label: refLabel(relation.target) });
    }
    if (descriptor.behaviors?.audit) {
        add({ name: "createdtime", type: "datetime", label: "Creato il" });
        add({ name: "modifiedtime", type: "datetime", label: "Modificato il" });
    }
    if (descriptor.behaviors?.ownership) {
        add({ name: "assigned_user_id", type: "ref", refTo: "user", label: "Assegnato a" });
    }
    if (descriptor.behaviors?.numbering) {
        add({ name: descriptor.behaviors.numbering.seq, type: "text", label: "Numero" });
    }
    return [...fields.values()];
}
export function getComplianceResources(options = {}) {
    const dataProviderName = options.dataProviderName ?? "kernel";
    return descriptors.map((descriptor) => {
        const map = coreBOSMap[descriptor.slug];
        const names = descriptor.fields.map((field) => field.name);
        const required = descriptor.fields.filter((field) => field.required).map((field) => field.name);
        return {
            name: descriptor.slug,
            list: `/${descriptor.slug}`,
            show: `/${descriptor.slug}/show/:id`,
            create: `/${descriptor.slug}/create`,
            edit: `/${descriptor.slug}/edit/:id`,
            meta: {
                dataProviderName,
                label: descriptor.label.plural,
                fields: fieldCatalog(descriptor),
                listView: map?.listView ?? names,
                showView: map?.showView ?? names,
                editView: map?.editView ?? names,
                createView: map?.createView ?? { fields: names, required, defaults: {} },
                searchFields: map?.searchFields ?? required,
                ...(descriptor.ui && typeof descriptor.ui === "object" ? { ui: descriptor.ui } : {}),
            },
        };
    });
}
